import { buttonClasses, SxProps } from '@mui/material'

interface BackAndForwardButtonsStyles {
  buttonWrapper: SxProps
  backButton: SxProps
  skipButton: SxProps
  buttonText: SxProps
}

export const backAndForwardButtonsStyles: BackAndForwardButtonsStyles = {
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  backButton: {
    display: 'flex',
    alignSelf: 'flex-start',
    p: 0,

    [`.${buttonClasses.startIcon}`]: {
      width: 10,
      height: 10,
    },
  },
  skipButton: {
    display: 'flex',
    alignSelf: 'flex-end',
    p: 0,

    [`.${buttonClasses.endIcon}`]: {
      width: 10,
      height: 10,
    },
  },
  buttonText: {
    typography: 'textXs',
    textTransform: 'none',
  },
}
